import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';


export default function NoSwipeGetCode(props){

    return(
<>
  <div style={{ color: "white" }}>
    <h2>
    <p>An activation code is required to continue using the whitelist and blacklist features after the trial period. The cost of the activation code is $11.99.</p>
    

<p>Before purchasing an activation code, please note the following:
<br/>
<ul>
<li>
  The activation code unlocks the whitelist and blacklist features. It is not required if you only want to disable swipe on all sites.
  </li><br/>
<li>
  The activation code is valid per installation. A new installation, <u>even on the same device</u>, will require a new code.
  </li><br/>
  <li>
The extension is provided "as is". Purchasing an activation code does not guarantee support. We recommend using it in trial mode before purchasing. 
  </li><br/>
<li>
  Future updates may change the behavior of the extension. If you prefer to avoid unexpected changes, consider disabling automatic updates.
  </li><br/>
<li>
  Future browser updates may cause the extension to malfunction.
  </li>
</ul>
</p>



    <p><u>How to get an activation code?</u></p>
    <ol>
      <li>Contact us using the form in the link below and request an activation code for the NoSwipe extension. Be sure to provide the email address you would like to use.</li>
      <li>You will receive instructions on where to send the payment via PayPal.</li>
      <li>Once we receive your payment (within 48 hours), we will send you the activation code.</li>
    </ol>

    <p><b style={{ color: "red" }}>Important: You must contact us and wait for our reply before sending any payments, even if you already know where to send the payment. This ensures we can confirm receipt and verify that we are available to process your subscription.</b></p>

    <NavLink to="../../en/contact">Contact us form link</NavLink>
    </h2>
  </div>
</>
    )
}